export const TYPES_ACTION = [
  { valeur: "Visite / RDV", icone: "◉", classe: "rdv" },
  { valeur: "Appel", icone: "☎", classe: "appel" },
  { valeur: "Relance", icone: "↻", classe: "relance" },
  { valeur: "Devis", icone: "▤", classe: "devis" },
  { valeur: "Contrat / Signature", icone: "✎", classe: "contrat" },
  { valeur: "BoutiqueClub", icone: "▣", classe: "boutique" },
  { valeur: "Livraison / Retrait", icone: "▰", classe: "livraison" },
  { valeur: "Impayé", icone: "!", classe: "impaye" },
  { valeur: "Tâche", icone: "✓", classe: "tache" },
  { valeur: "RELANCE SIMPLE", icone: "↻", classe: "relance", pointCommercial: true },
  { valeur: "RELANCE RENFORCÉE", icone: "↻", classe: "relance", pointCommercial: true },
  { valeur: "APPEL", icone: "☎", classe: "appel", pointCommercial: true },
  { valeur: "VISITE", icone: "◉", classe: "rdv", pointCommercial: true },
  { valeur: "CONTRÔLE RÈGLEMENT", icone: "!", classe: "impaye", pointCommercial: true },
  { valeur: "CONTRÔLE LIVRAISON", icone: "▰", classe: "livraison", pointCommercial: true },
  { valeur: "CONTRÔLE FACTURATION", icone: "▤", classe: "devis", pointCommercial: true },
  { valeur: "RENOUVELLEMENT CONTRAT", icone: "✎", classe: "contrat", pointCommercial: true },
  { valeur: "PRÉPARER DEVIS", icone: "▤", classe: "devis", pointCommercial: true },
  { valeur: "ENVOYER OFFRE", icone: "▤", classe: "devis", pointCommercial: true },
  { valeur: "AUTRE", icone: "✓", classe: "tache", pointCommercial: true }
];

export const TYPES_ACTION_POINT_COMMERCIAL = TYPES_ACTION.filter((type) => type.pointCommercial);

const PREFIXE = "[[CRM_ACTION_V1:";
const PREFIXE_B64 = "[[CRM_ACTION_B64_V1:";
const FIN_PREFIXE = "]]";

const TYPES_HISTORIQUES = {
  "Visite club": "Visite / RDV",
  Prospection: "Visite / RDV",
  Offre: "Devis",
  Commande: "Devis",
  Livraison: "Livraison / Retrait",
  "Animation club": "Visite / RDV",
  "Soirée privée": "Visite / RDV",
  Suivi: "Tâche"
};

export function normaliserTypeAction(type) {
  const valeur = TYPES_HISTORIQUES[type] || type || "Tâche";
  return TYPES_ACTION.some((item) => item.valeur === valeur) ? valeur : "Tâche";
}

export function infosTypeAction(type) {
  const valeur = normaliserTypeAction(type);
  return TYPES_ACTION.find((item) => item.valeur === valeur) || TYPES_ACTION[TYPES_ACTION.length - 1];
}

export function lireCommentaireAction(commentaire) {
  const texte = String(commentaire || "");
  if (texte.startsWith(PREFIXE_B64)) {
    const finB64 = texte.indexOf(FIN_PREFIXE, PREFIXE_B64.length);
    try {
      const source = texte.slice(PREFIXE_B64.length, finB64).replaceAll("-", "+").replaceAll("_", "/");
      const binaire = window.atob(source.padEnd(Math.ceil(source.length / 4) * 4, "="));
      const meta = JSON.parse(new TextDecoder().decode(Uint8Array.from(binaire, (caractere) => caractere.charCodeAt(0))));
      return { note: texte.slice(finB64 + FIN_PREFIXE.length).replace(/^\n/, ""), meta: { version: 1, statut: "planifie", priorite: "Normale", ...meta } };
    } catch (_erreur) {
      return { note: texte, meta: { version: 0, statut: "planifie", priorite: "Normale" } };
    }
  }
  if (!texte.startsWith(PREFIXE)) {
    return { note: texte, meta: { version: 0, statut: "planifie", priorite: "Normale" } };
  }
  const fin = texte.indexOf(FIN_PREFIXE, PREFIXE.length);
  if (fin < 0) return { note: texte, meta: { version: 0, statut: "planifie", priorite: "Normale" } };
  try {
    const meta = JSON.parse(decodeURIComponent(texte.slice(PREFIXE.length, fin)));
    return {
      note: texte.slice(fin + FIN_PREFIXE.length).replace(/^\n/, ""),
      meta: { version: 1, statut: "planifie", priorite: "Normale", ...meta }
    };
  } catch (_erreur) {
    return { note: texte, meta: { version: 0, statut: "planifie", priorite: "Normale" } };
  }
}

export function encoderCommentaireAction(note, meta = {}) {
  const donnees = { version: 1, statut: "planifie", priorite: "Normale", ...meta };
  return `${PREFIXE}${encodeURIComponent(JSON.stringify(donnees))}${FIN_PREFIXE}\n${String(note || "").trim()}`;
}

export function dateLocaleIso(date) {
  const d = new Date(date);
  const annee = d.getFullYear();
  const mois = String(d.getMonth() + 1).padStart(2, "0");
  const jour = String(d.getDate()).padStart(2, "0");
  return `${annee}-${mois}-${jour}`;
}

export function lundiDeLaSemaine(dateSource = new Date()) {
  const date = new Date(dateSource);
  date.setHours(0, 0, 0, 0);
  const jour = date.getDay() || 7;
  date.setDate(date.getDate() - jour + 1);
  return date;
}

export function joursSemaine(dateSource = new Date()) {
  const lundi = lundiDeLaSemaine(dateSource);
  return Array.from({ length: 6 }, (_, index) => {
    const date = new Date(lundi);
    date.setDate(lundi.getDate() + index);
    return date;
  });
}

export function numeroSemaine(dateSource = new Date()) {
  const date = new Date(Date.UTC(dateSource.getFullYear(), dateSource.getMonth(), dateSource.getDate()));
  const jour = date.getUTCDay() || 7;
  date.setUTCDate(date.getUTCDate() + 4 - jour);
  const debut = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));
  return Math.ceil((((date - debut) / 86400000) + 1) / 7);
}

export function finAction(heure, duree) {
  if (!heure || duree === "journee") return "";
  const [heures, minutes] = heure.slice(0, 5).split(":").map(Number);
  const durees = { "30min": 30, "1h": 60, "2h": 120, "3h": 180, "demi-journee": 240 };
  const total = heures * 60 + minutes + (durees[duree] || 60);
  return `${String(Math.floor(total / 60) % 24).padStart(2, "0")}:${String(total % 60).padStart(2, "0")}`;
}

export function statutAction(action, maintenant = new Date()) {
  const { meta } = lireCommentaireAction(action.commentaire);
  const statut = String(meta.statut || "").toLocaleLowerCase("fr-FR");
  if (["annule", "annulee", "annulé", "annulée"].includes(statut)) return "annule";
  if (["faite", "termine", "terminee", "terminée", "realise", "réalisé", "realisee", "réalisée"].includes(statut)) return "termine";
  if (meta.statut === "a_relancer" || meta.resultat === "À relancer") return "a_relancer";
  const date = action.date_rdv ? new Date(`${action.date_rdv}T${String(action.heure_rdv || "23:59").slice(0, 5)}:00`) : null;
  return date && date < maintenant ? "en_retard" : "planifie";
}

export function estActionRealisee(action) {
  const statut = String(lireCommentaireAction(action?.commentaire).meta.statut || "").trim().toLocaleLowerCase("fr-FR");
  return ["faite", "termine", "terminee", "terminée", "realise", "réalisé", "realisee", "réalisée"].includes(statut);
}

export function estVisiteRealisee(action) {
  const type = String(action?.type || "").trim().toLocaleLowerCase("fr-FR");
  return (type.includes("visite") || normaliserTypeAction(action?.type) === "Visite / RDV") && estActionRealisee(action);
}

export function compteursPlanning(actions, maintenant = new Date()) {
  const aujourdHui = dateLocaleIso(maintenant);
  const semaine = new Set(joursSemaine(maintenant).map(dateLocaleIso));
  return {
    aujourdHui: actions.filter((action) => action.date_rdv === aujourdHui && !["termine", "annule"].includes(statutAction(action, maintenant))).length,
    enRetard: actions.filter((action) => statutAction(action, maintenant) === "en_retard").length,
    cetteSemaine: actions.filter((action) => semaine.has(action.date_rdv) && statutAction(action, maintenant) !== "annule").length,
    aRelancer: actions.filter((action) => statutAction(action, maintenant) === "a_relancer").length
  };
}

export function actionDansPerimetre(action, utilisateur, filtreCommercial) {
  const role = String(utilisateur?.role || "").toLowerCase();
  const nom = String(utilisateur?.nom || "");
  const peutVoirEquipe = ["superviseur", "gestionnaire", "admin", "admin_groupe"].includes(role);
  if (!peutVoirEquipe) return String(action.commercial || "") === nom;
  if (!filtreCommercial || filtreCommercial === "Tous") return true;
  return String(action.commercial || "") === String(filtreCommercial);
}
